import api from './api';

export const userAPI = {
  /**
   * Récupérer tous les utilisateurs
   * @param {Object} params - Paramètres de filtrage
   * @returns {Promise}
   */
  getAll: async (params = {}) => {
    const response = await api.get('/user', { params });
    return response.data;
  },

  /**
   * Récupérer un utilisateur par son ID
   * @param {String} id - L'ID de l'utilisateur
   * @returns {Promise}
   */
  getById: async (id) => {
    const response = await api.get(`/user/${id}`);
    return response.data;
  },

  /**
   * Mettre à jour un utilisateur
   * @param {String} id - L'ID de l'utilisateur
   * @param {Object} userData - Les nouvelles données
   * @returns {Promise}
   */
  update: async (id, userData) => {
    const response = await api.put(`/user/${id}`, userData);
    return response.data;
  },

  /**
   * Supprimer un utilisateur
   * @param {String} id - L'ID de l'utilisateur
   * @returns {Promise}
   */
  delete: async (id) => {
    const response = await api.delete(`/user/${id}`);
    return response.data;
  },

  /**
   * Récupérer les tentatives d'un utilisateur
   * @param {String} userId - L'ID de l'utilisateur
   * @returns {Promise}
   */
  getAttempts: async (userId) => {
    const response = await api.get(`/user/${userId}/attempts`);
    return response.data;
  }
};

export default userAPI;

